import { render, staticRenderFns } from "./business.vue?vue&type=template&id=3acbe4da"
import script from "./business.vue?vue&type=script&lang=ts"
export * from "./business.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports